var storefrontApp = angular.module("storefrontApp");
storefrontApp.controller("MembershipPaymentController", [
    "$rootScope",
    "$scope",
    "storefrontApp.mainContext",
    "membershipService",
    "commonService",
    "creditCardService",
    "orderService",
    "accountService",
    "notificationModalService",
    "$window",
    "cartService",
    function (
        $rootScope,
        $scope,
        mainContext,
        membershipService,
        commonService,
        creditCardService,
        orderService,
        accountService,
        notificationModalService,
        $window,
        cartService
    ) {
        //#region Scope Objects
        $scope.coupon = "";
        $scope.applyCoupon = false;
        $scope.couponValid = null;
        $scope.ccForPayment = {};
        $scope.profileView = {
            address: {},
            countries: [],
            addressesMaster: [],
        };
        $scope.membershipCheckout = {
            paymentMethods: [],
            payment: {},
            billingAddressId: "",
            creditCardId: "",
            isValid: false,
            isFreeOrder: false,
        };

        //#region Saved Order
        $scope.savedOrder = {
            orderNumber: "",
            isEnabled: false,
            showModal: false,
            redirectText: "Ann's Club",
        };
        //#endregion
        //#endregion

        //#region Watch on Customer
        $scope.$watch(
            function () {
                return mainContext.customer;
            },
            function (customer) {
                if (customer) {
                    $rootScope.showLoader = true;
                    $scope.customerId = customer.contactId;
                    $scope.profileView.addressesMaster = customer.addresses;
                    $scope.customerPreference = customer.customerPreferences[0];
                    $scope.getCustomerCCards();
                    $scope.initialize();
                } else {
                    console.log("Could not get the customer Info Loaded");
                }
            }
        );
        //#endregion

        //#region Payment Related
        $scope.getAvailableClubPaymentMethods = function () {
            $scope.validCVV = false;
            if (document.getElementById("cvv")) {
                document.getElementById("cvv").value = "";
            }
            membershipService
                .getMembershipPaymentMethods()
                .then(function (response) {
                    if (response && response.data) {
                        $scope.membershipCheckout.paymentMethods =
                            response.data;
                        $scope.membershipCheckout.payment = response.data[0];
                    }
                });
        };

        $scope.toggleCVVHelp = function (state) {
            $rootScope.showCVVHelp = state;
        };

        $scope.getCardBillingAddresses = function () {
            $scope.cardView.paymentCardsInfo.forEach(function (card) {
                card.expMonth = card.expireDate.split("/")[0];
                card.expYear = "20" + card.expireDate.split("/")[1];
                card.maskedCard = "XXXX XXXX XXXX " + card.last4Digits;
                card.isExpired = commonService.validateCardExpiryDate(
                    card.expYear,
                    card.expMonth
                );
                var address = $scope.profileView.addressesMaster.filter(
                    function (address) {
                        return address.key == card.fK_AddressId;
                    }
                );
                card.billingAddress =
                    address && address.length > 0 && address[0];
            });
        };

        $scope.setPristineCardView = function (modalClose) {
            modalClose && $scope.onModalClose();
            $scope.validCVV = false;
            if (document.getElementById("cvv")) {
                document.getElementById("cvv").value = "";
            }
            $scope.getCardBillingAddresses();
        };

        $scope.getCustomerCCards = function () {
            creditCardService
                .getCreditCards($scope.customerId)
                .then(function (response) {
                    $scope.cardView.paymentCardsInfo = response.data || [];
                    if (response && response.data != "") {
                        $scope.getCardBillingAddresses();
                        //Customer has CC then pick the CC for Payment
                        if (response.data.length == 1) {
                            $scope.ccForPayment = response.data[0];
                        } else {
                            var defaultCC = $scope.getDefaultCC(response.data);
                            if (defaultCC && defaultCC.length > 0) {
                                $scope.ccForPayment = defaultCC[0];
                            } else {
                                $scope.ccForPayment = response.data[0];
                            }
                        }
                        //Get Billing Address associated with CC
                        if ($scope.ccForPayment != null) {
                            var billingAddress = $scope.getBillingAddress(
                                $scope.ccForPayment.fK_AddressId
                            );

                            if (billingAddress && billingAddress.length > 0) {
                                $scope.membershipCheckout.billingAddressId =
                                    $scope.ccForPayment.fK_AddressId;
                                $scope.membershipCheckout.creditCardId =
                                    $scope.ccForPayment.id;
                                $scope.ccForPayment.billingAddress =
                                    billingAddress[0];
                            } else {
                                $scope.ccForPayment = null;
                            }
                            $scope.validCVV = false;
                        }
                    } else {
                        $scope.ccForPayment = null;
                    }
                });
        };

        $scope.setPristineAddOrEditForm = function () {
            if (
                $scope.profileView.forms.address &&
                Object.keys($scope.profileView.forms.address).length > 0
            ) {
                $scope.profileView.forms.address.$setUntouched();
                $scope.profileView.forms.address.$setPristine();
            }
            if ($scope.cardView && $scope.cardView.cardInfotoEdit) {
                $scope.cardView.cardInfotoEdit.fK_AddressId = "";
            }
            $rootScope.appModalOpen = false;
            $scope.profileView.showAddAddress = false;
            $scope.profileView.showEditAddress = false;
            $scope.profileView.address = {};
        };

        $scope.getNumber = function (num) {
            return new Array(num);
        };

        $scope.validateCVV = function () {
            $scope.cvv = document.getElementById("cvv").value;

            if ($scope.ccForPayment.creditCardCompany.toLowerCase() == "amex") {
                if ($scope.cvv.length == 4) {
                    $scope.validCVV = true;
                } else {
                    $scope.validCVV = false;
                }
            } else {
                if ($scope.cvv.length == 3) {
                    $scope.validCVV = true;
                } else {
                    $scope.validCVV = false;
                }
            }
        };

        $scope.getDefaultCC = function (ccList) {
            return ccList.filter(function (cc) {
                return cc.isDefault == true;
            });
        };

        $scope.cardFormatter = function (value) {
            if (value) {
                document.getElementById("cardNumber").value = value
                    .substring(0, 19)
                    .replace(/(\d{4})(\d+)/g, "$1 $2");
                $scope.cardType = creditCardService.getCreditCardType(value);
            }
        };

        $scope.validateCard = function () {
            var result = creditCardService.getCreditCardType(
                $scope.cardView.cardInfotoEdit.number
            );
            $scope.cardView.paymentInfoForm.cardNumber.$setValidity(
                "invalidCard",
                result ? true : false
            );
        };

        $scope.validateCardExpiry = function () {
            if (
                angular.isDefined($scope.cardView) &&
                angular.isDefined($scope.cardView.cardInfotoEdit) &&
                angular.isDefined($scope.cardView.cardInfotoEdit.expMonth) &&
                angular.isDefined($scope.cardView.cardInfotoEdit.expYear)
            ) {
                if (
                    commonService.validateCardExpiryDate(
                        $scope.cardView.cardInfotoEdit.expYear,
                        $scope.cardView.cardInfotoEdit.expMonth
                    )
                ) {
                    $scope.cardView.paymentInfoForm.expMonth.$setValidity(
                        "validexpiry",
                        false
                    );
                } else {
                    $scope.cardView.paymentInfoForm.expMonth.$setValidity(
                        "validexpiry",
                        true
                    );
                }
            }
        };

        //#region Add or Edit Credit Card Information
        $scope.onAddPayment = function (title) {
            $scope.showPaymentMethods = false;
            $scope.showAddPayment = true;
            $scope.modalHeaderTitle = title;
            $scope.cardView.cardInfotoEdit =
                $scope.cardView.paymentCardsInfo.length == 0
                    ? { isDefault: true }
                    : null;
        };

        $scope.selectAsPaymentSrc = function (card) {
            if (!card.isExpired) {
                $scope.ccForPayment = card;
                $scope.showPaymentMethods = false;
                $scope.validCVV = false;
            } else {
                alert("Expired card can't be used");
            }
        };

        $scope.onAddOrEditPaymentSubmit = function () {
            var cardDto = toCardDto($scope.cardView.cardInfotoEdit);
            creditCardService.addCard(cardDto).then(function (response) {
                if (response.data) {
                    $scope.getCustomerCCards();
                    $scope.showAddPayment = false;
                    $scope.showPaymentMethods = true;
                    $rootScope.notificationModal =
                        notificationModalService.getNotificationModal(
                            "ADDCARD"
                        );
                }
            });
            $scope.validCVV = false;
            if (document.getElementById("cvv")) {
                document.getElementById("cvv").value = "";
            }
        };

        function toCardDto(card) {
            return {
                id: card.id,
                createdDate: card.createdDate,
                userId: $scope.customerId,
                creditCardCompany: creditCardService.getCreditCardType(
                    card.number
                ),
                creditCardNumber:
                    creditCardService.cardNumberWithoutSpaces(card.number) ||
                    "",
                nameOnCard: getContactName(card.fK_AddressId),
                fK_AddressId: card.fK_AddressId,
                nicknameForCard: card.nicknameForCard,
                expireDate: creditCardService.getExpiryDate(
                    card.expMonth,
                    card.expYear
                ),
                isDefault: card.isDefault,
            };
        }
        //#endregion

        //#endregion

        //#region Address Related
        $scope.getBillingAddress = function (addressId) {
            var billingAddress = $scope.profileView.addressesMaster.filter(
                function (addr) {
                    return addr.key == addressId;
                }
            );
            return billingAddress;
        };

        function getContactName(key) {
            var address = $scope.profileView.addressesMaster.filter(function (
                item
            ) {
                return item.key == key;
            });
            return (
                address &&
                address.length > 0 &&
                address[0].firstName + " " + address[0].lastName
            );
        }
        //#endregion

        //#region Initialize
        $scope.initialize = function () {
            $rootScope.isCheckoutPage = true;
            $scope.selectedSrc = "Paypal.DirectPayment";
            $scope.ccForPayment = "CCForPayment";
            $scope.showWallet = true;
            $scope.validCVV = false;
            $scope.cardView = {
                cardInfotoEdit: null,
                paymentCardsInfo: [],
                paymentInfoForm: {},
            };
            $scope.createYearList();
            $scope.getAvailableClubPaymentMethods();
            $scope.getCustomerCCards();
        };
        //#endregion

        //#region Modal PopUp
        $scope.onShowWallet = function (title) {
            $scope.showPaymentMethods = true;
            $scope.modalHeaderTitle = title;
        };

        $scope.onModalClose = function () {
            if (
                angular.isDefined($scope.showAddPayment) &&
                $scope.showAddPayment
            ) {
                $scope.showAddPayment = false;
                $scope.showPaymentMethods = true;
                $scope.modalHeaderTitle = "Manage Payment Methods";
            } else {
                $scope.showPaymentMethods = false;
            }
        };

        $scope.createYearList = function (selectedYear) {
            var currentYear = new Date().getFullYear();
            var selected = parseInt(selectedYear, 10);
            $scope.yearList = [];
            // Keep a past selected expiry year visible without offering other past years
            if (!isNaN(selected) && selected < currentYear) {
                $scope.yearList.push(selected.toString());
            }
            for (var i = 0; i < 15; i++) {
                $scope.yearList.push((currentYear + i).toString());
            }
        };
        //#endregion

        //#region Submit Order & Validations
        $scope.SetSubmitButtonValidation = function () {
            if (
                $scope.ccForPayment &&
                $scope.ccForPayment.billingAddress &&
                $scope.validCVV &&
                !$scope.ccForPayment.isExpired
            ) {
                return false;
            } else {
                return true;
            }
        };
        $scope.ValidateCheckout = function () {
            if (
                $scope.ccForPayment &&
                $scope.ccForPayment.billingAddress &&
                $scope.validCVV
            ) {
                $scope.membershipCheckout.isValid = true;
            } else {
                $scope.membershipCheckout.isValid = false;
            }
            if ($scope.membershipCheckout.isValid) {
                return true;
            } else {
                return false;
            }
        };
        $scope.submitMembershipOrder = function () {
            if ($scope.ValidateCheckout()) {
                $rootScope.showLoader = true;
                $rootScope.notificationModal =
                    notificationModalService.getNotificationModal(
                        "ORDERPROCEEDING"
                    );
                console.log("Hold Tight - Placing Membership Order");
                if (
                    angular.isDefined($window.membershipPlan) &&
                    angular.isDefined($scope.ccForPayment)
                ) {
                    var planId = $window.membershipPlan.planId || "";
                    var planTenure = $window.membershipPlan.planTenure || "";
                    var planName = $window.membershipPlan.planName || "";
                    var planPrice = $window.membershipPlan.planPrice || "";
                    membershipService
                        .placeMembershipOrder(
                            $scope.ccForPayment.id,
                            $scope.ccForPayment.billingAddress.key,
                            $scope.cvv,
                            planId,
                            planTenure,
                            planName,
                            planPrice
                        )
                        .then(function (response) {
                            if (response && response.data) {
                                var order = response.data.order;
                                var orderProcessingResult =
                                    response.data.orderProcessingResult;
                                var paymentMethod = response.data.paymentMethod;
                                HandlePostMembershipCheckoutEvents(
                                    order,
                                    orderProcessingResult,
                                    paymentMethod
                                );
                            } else {
                                alert("Transaction failed!");
                            }
                        });
                }
            } else {
                console.log("Cart is not Valid");
            }
            $rootScope.showLoader = false;
        };
        function HandlePostMembershipCheckoutEvents(
            order,
            orderProcessingResult,
            paymentMethod
        ) {
            if (
                orderProcessingResult != null &&
                !orderProcessingResult.isSuccess
            ) {
                HandleSavedOrderPostCheckoutError(order && order.number);
                $rootScope.returnError = true;
                return;
            }
            if (
                paymentMethod.paymentMethodType &&
                paymentMethod.paymentMethodType.toLowerCase() ==
                    "redirection" &&
                orderProcessingResult.redirectUrl
            ) {
                $window.location.href = orderProcessingResult.redirectUrl;
            } else {
                $rootScope.notificationModal =
                    notificationModalService.getNotificationModal(
                        "ORDERSUCCESS"
                    );
                $scope.outerRedirect(
                    $scope.baseUrl + "cart/thanks/" + order.number
                );
            }
        }
        //#endregion

        //#region Saved Orders
        $scope.saveOrder = function () {
            orderService
                .saveCustomerOrder($scope.savedOrder.number)
                .then(function (response) {
                    if (response && response.data)
                        $window.location.href =
                            $scope.baseUrl + "account/orderhistory";
                    else {
                        $scope.savedOrder.showModal = false;
                        $rootScope.notificationModal =
                            notificationModalService.getNotificationModal(
                                "ORDERERROR"
                            );
                    }
                });
        };

        function HandleSavedOrderPostCheckoutError(orderNumber) {
            $scope.savedOrder.number = orderNumber;
            if ($scope.savedOrder.number)
                orderService.isSavedOrderEnabled().then(function (response) {
                    $scope.savedOrder.isEnabled = $scope.savedOrder.showModal =
                        response && response.data;
                    if ($scope.savedOrder.isEnabled)
                        $rootScope.notificationModal.show = false;
                    else
                        $rootScope.notificationModal =
                            notificationModalService.getNotificationModal(
                                "ORDERERROR"
                            );
                });
            else
                $rootScope.notificationModal =
                    notificationModalService.getNotificationModal("ORDERERROR");
        }
        // #endregion

        //#region Add Address
        var defaultCountryCode = "US";
        $scope.getmodalCountryRegions = function () {
            var countryCode = $scope.profileView.address.countryCode;
            countryCode &&
                membershipService
                    .getCountryRegions(countryCode)
                    .then(function (response) {
                        $scope.profileView.modalCountryRegions =
                            response.data || [];
                    });
        };

        function getAvailableCountries() {
            membershipService.getCountries().then(function (response) {
                $scope.profileView.countries = response.data || [];
            });
        }
        getAvailableCountries();

        $scope.viewAddAddress = function () {
            $rootScope.appModalOpen = true;
            $scope.profileView.showAddAddress = true;
            $scope.profileView.address.isDefault =
                $scope.profileView.addressesMaster.length == 0;
            $scope.profileView.address.countryCode = defaultCountryCode;
            $scope.getmodalCountryRegions();
        };

        function toCustomerAddressDto(address, regions, isDefault) {
            var customerAddress = {
                isDefault: isDefault,
                addressItem: {
                    key: address.key,
                    name: address.name,
                    firstName: address.firstName,
                    lastName: address.lastName,
                    line1: address.line1,
                    line2: address.line2,
                    city: address.city,
                    regionId: address.regionId,
                    regionName: getCountryRegionName(regions, address.regionId),
                    countryCode: address.countryCode,
                    countryName: getCountryName(address.countryCode),
                    postalCode: address.postalCode,
                },
            };
            return customerAddress;
        }

        $scope.onAddOrEditAddressSubmit = function () {
            if ($scope.profileView.forms.address.$valid) {
                var customerAddress = toCustomerAddressDto(
                    $scope.profileView.address,
                    $scope.profileView.modalCountryRegions,
                    $scope.profileView.address.isDefault
                );
                addOrUpdateAddress(customerAddress);
            }
        };

        function getCountryName(countryCode) {
            var country = $scope.profileView.countries.filter(function (
                country
            ) {
                return country.code2 == countryCode;
            });
            return country && country.length > 0 && country[0].name;
        }

        function getCountryRegionName(regions, regionId) {
            var region = regions.filter(function (region) {
                return region.code == regionId;
            });
            return region && region.length > 0 && region[0].name;
        }

        function addOrUpdateAddress(customerAddress) {
            //Update is not required here..
            accountService
                .addNewAddress(customerAddress)
                .then(function (response) {
                    $scope.profileView.addressesMaster =
                        response.data.addresses || [];
                    $rootScope.appModalOpen = false;
                    $scope.profileView.showAddAddress = false;
                    $rootScope.notificationModal =
                        notificationModalService.getNotificationModal(
                            "ADDADDRESS"
                        );
                });
        }
        //#endregion

        $rootScope.closeNotificationModal = function () {
            $scope.outerRedirect($scope.baseUrl + "annsclub");
        };

        //#region Coupon Related Methods
        $scope.removeCoupon = function () {
            localStorage.removeItem("IsCouponApplied");
            localStorage.removeItem("AppliedCoupon");
        };

        $scope.onCouponApply = function (couponCode) {
            try {
                if (couponCode.length > 0) {
                    $rootScope.showLoader = true;
                    var coupon = {
                        Code: "",
                        Description: "",
                        AppliedSuccessfully: false,
                        ErrorCode: "",
                    };
                    coupon.Code = couponCode;
                    return cartService
                        .validateCoupon(coupon)
                        .then(function (result) {
                            $rootScope.showLoader = false;
                            $scope.appliedCoupon = couponCode;
                            $scope.couponValid =
                                result.data.appliedSuccessfully;
                            if ($scope.couponValid) {
                                localStorage.setItem("IsCouponApplied", true);
                                localStorage.setItem(
                                    "AppliedCoupon",
                                    $scope.appliedCoupon
                                );
                                cartService
                                    .addCoupon(result.data.code)
                                    .then(function () {
                                        $window.location.reload();
                                    });
                            }
                        });
                } else {
                    $scope.couponValid = false;
                }
            } catch (err) {
                $rootScope.showLoader = false;
            }
        };

        $scope.toggleCouponSection = function (state) {
            $scope.coupon = null;
            $scope.couponValid = null;
            $scope.applyCoupon = state;
        };

        $scope.onCouponKeyPress = function (event) {
            if (event && event.which === 13) {
                $scope.onCouponApply(event.target.value);
            }
        };
        //#endregion
    },
]);
